import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate  } from 'react-router-dom';
import Typography from '@mui/material/Typography'; 
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import ImageUploading from "react-images-uploading";
import CircularProgress from '@mui/material/CircularProgress';
import { TradableBitsValidation } from '../../assets/validation/validation';
import FormHelperText from '@mui/material/FormHelperText';
import { tradableBitsAction } from '../../redux/actions/tradablebitsAction'; 
import { Loader } from "../../errorPages/Loader";


export default function TradableBitsAdd() {
    const [statuss, setStatuss] = useState(true);
    const [data, setData] = React.useState([]);
    
    const [images, setImages] = React.useState([]);
    const [imageError, setImageError] = React.useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const maxNumber = 1;

    const onChange = (imageList, addUpdateIndex) => {
      setImages(imageList);
      if(imageList.length > 0) {
        setImageError("");
      }
    };

    const onErrorChange = (errors, files) => {
        if(errors){
            setImages([]);
        }
    };
    
    const handleStatusChange = (event) => {
        setStatuss(event.target.value);
    };
  

    useEffect(() => { 
        dispatch(tradableBitsAction.getAll()); 
           // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
    
    const {bits_data , bits_status , loading } = useSelector(state => state.tradablebits);   

    useEffect(() => { 
        if(bits_status === true){
            setData(bits_data);
        }
    }, [bits_status, bits_data])


    useEffect(() => { 
        if(data && data.length > 0){
            if(data[0]._id){
                setTimeout(function () {
                    navigate("/tradablebits/view/"+data[0]._id)
                }, 100);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])
  

  return (
    <Box sx={{ mb:3 }} className='cardWrapper'>
         {loading ? <Loader/> : '' }
         <div className="pageTitleWrap">
            <Stack  direction="row" spacing={1}   alignItems="center">
                <Typography type="submit" variant="text" component={Link} to={"/"} > TradableBits</Typography>
                <Typography className="" component={"h2"} variant="h2" >
                    / Add Bits
                </Typography>
            </Stack>
        </div>
        <Formik
            initialValues={{
                name : '',
                tradableBitsUrl :'',
                status: statuss,
            }}
            validationSchema={TradableBitsValidation}
           //enableReinitialize
            onSubmit={(values, {setErrors, setSubmitting}) => {
                console.log(values, "values");
                let form_data = new FormData();
                form_data.append('name', values.name);
                form_data.append('tradableBitsUrl', values.tradableBitsUrl);
                form_data.append('status', values.status);
                if(images && images.length > 0){
                    images.map((field, idx) => {
                        if(field.file){
                            form_data.append('file', field.file);
                        }
                        return true;
                    });
                    setImageError(""); 

                } else {
                    setImageError("Icon is missing.  Please update the icon.");
                    return false;
                }
                dispatch(tradableBitsAction.add(form_data, setErrors, setSubmitting, navigate));  
               
            }}>
            {({ errors, touched, values, handleChange, handleBlur, handleSubmit, handleReset, isSubmitting, setFieldValue }) => (
            <form onSubmit={handleSubmit}> 
                <Card sx={{}} variant="outlined" className="formWrapper">
                    <CardHeader title="Add"/>
                    <CardContent > 
                        <Grid container spacing={2} alignItems="stretch">
                            <Grid item lg={5} xl={5} sx={{pr:5}}>
                                <TextField
                                    error={errors.name && touched.name}
                                    label="Name"
                                    fullWidth 
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={(e) => {
                                        const val = (e.target.value || '').replace(/\s+/gi, ' ');
                                        setFieldValue(e.target.name, val.trim());
                                        handleBlur(e);
                                    }}
                                    helperText={(errors.name && touched.name) && errors.name}
                                    margin="normal"
                                    variant="outlined"
                                    required={false}
                                    InputLabelProps={{ required: true }} 
                                />
                                <TextField
                                    error={errors.tradableBitsUrl && touched.tradableBitsUrl}
                                    label="URL"
                                    fullWidth 
                                    name="tradableBitsUrl"
                                    value={values.tradableBitsUrl}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    helperText={(errors.tradableBitsUrl && touched.tradableBitsUrl) && errors.tradableBitsUrl}
                                    margin="normal"
                                    variant="outlined"
                                    required={false}
                                    InputLabelProps={{ required: true }} 
                                />
                                <FormControl sx={{mt:2, width:"100%", textAlign:"left"}}>
                                    <FormLabel id="demo-row-radio-buttons-group-label">Status <span>*</span></FormLabel>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="status"
                                        value={statuss}
                                        onChange={(event) => {
                                            handleChange(event);
                                            handleStatusChange(event); 
                                        }}
                                    >
                                        <FormControlLabel value={true} control={<Radio />} label="Active" />
                                        <FormControlLabel value={false} control={<Radio />} label="Inactive" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        
                            <Grid item lg={7} xl={7} sx={{}} >
                            <ImageUploading
                                value={images}
                                onChange={onChange}
                                onError={onErrorChange}
                                maxFileSize={512000}
                                maxNumber={maxNumber}
                                dataURLKey="data_url"
                                acceptType={["png"]}
                                resolutionType="absolute"	
                                resolutionWidth={256}
                                resolutionHeight={256}
                            >
                                {({
                                imageList,
                                onImageUpload,
                                onImageRemoveAll,
                                onImageUpdate,
                                onImageRemove,
                                isDragging,
                                dragProps,
                                errors 
                                }) => (
                                // write your building UI
                                
                                <div className="upload__image-wrapper">
                                    <Card sx={{height:"95%", border:"1px solid rgba(20,20,20,0.2)", background:"#f8f8f8", minHeight:"250px", maxHeight:"250px", display:"flex", justifyContent:"center", alignItems:"center"}} elevation={0}>
                                    {images && images.length > 0 ?
                                        images.map((image, index) => {
                                            return (
                                                <div key={index} className="image-item">
                                                    <CardMedia
                                                        component="img"
                                                        height="100%"
                                                        image={image.data_url}
                                                        alt="green iguana"
                                                        onClick={() => onImageUpdate(index)}
                                                    />
                                                    <div className="image-item__btn-wrapper">
                                                        <IconButton className='delete_icon'  onClick={() => onImageRemove(index)}>
                                                            <i className='icon-close'></i>
                                                        </IconButton>
                                                    </div>
                                                </div>
                                            )
                                        })
                                        :
                                        <CardContent sx={{p:"0 !important", height:"100%"}}>
                                            <Box 
                                                onClick={onImageUpload}
                                                {...dragProps}
                                            >
                                                 <span className='upload_icon'><i className='icon-upload'></i></span>
                                                <span className='upload_content'>Upload Icon</span>
                                            </Box>
                                        </CardContent>
                                        
                                        }
                                     </Card>
                                     {errors ?
                                        <FormHelperText error={true}>
                                            {errors.acceptType && <span>Selected file type is not allow</span>}
                                            {errors.maxFileSize && <span>Icon's size cannot exceed 500 KB</span>}
                                            {errors.resolution && <span>Selected file is not matching desired resolution</span>}
                                        </FormHelperText >
                                    : <FormHelperText error={true}>{imageError}</FormHelperText>
                                    }
                                    <Stack className='upload__helpText' direction="row" spacing={2} justifyContent="space-between"  alignItems="center">
                                        <Typography  variant="body1" component="p" >
                                            File Size: Max 500 KB
                                        </Typography>
                                        <Typography  variant="body1" component="p" >
                                            File Resolution: <b>256 x 256</b>
                                        </Typography> 
                                        <Typography  variant="body1" component="p" >
                                            File Format: .png
                                        </Typography>
                                    </Stack>
                                  
                                    
                                </div>
                                )}
                            </ImageUploading>
                            </Grid>
                        </Grid> 
                    </CardContent>
                    <CardActions sx={{justifyContent:"center"}}>
                        <Button type="submit" variant="contained" color="primary"
                          disabled ={isSubmitting} 
                        > {isSubmitting ? <CircularProgress size={20}/> :  "Submit"}</Button> 
                        <Button type="button" variant="contained" color="secondary"
                        onClick={(e) => {    
                            handleReset();
                            navigate(-1);
                        }}
                        >Cancel</Button>
                    </CardActions>
                </Card>  
            </form>
            )}
        </Formik>    
    </Box>
  )
}
